import logoTeensIBP from '../assets/teensibp-logo.png';

/**
 * A marca do ministério.
 *
 * É a arte real, não um desenho nosso: antes havia aqui um patch quadrado
 * inventado, com o texto em SVG pedindo uma fonte que deixou de ser
 * carregada — então caía num fallback silencioso. A ilustração é orgânica e
 * desenhada à mão; traçá-la em SVG seria redesenhá-la, e por isso entra como
 * imagem, recortada em círculo com os cantos transparentes para funcionar
 * igual sobre o preto e sobre o papel.
 *
 * É a única forma redonda do sistema, junto do carimbo — e por bom motivo:
 * as duas são identidade, não interface.
 */
export function Logo({ tamanho = 44 }: { tamanho?: number }) {
  return (
    <img
      src={logoTeensIBP}
      width={tamanho}
      height={tamanho}
      alt="TeensIBP"
      style={{ flexShrink: 0 }}
    />
  );
}

export function Marca({ subtitulo }: { subtitulo?: string }) {
  return (
    <div className="linha" style={{ gap: 'var(--gap-3)', flexWrap: 'nowrap' }}>
      <Logo />
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontFamily: 'var(--fonte-display)',
            fontSize: 'var(--texto-lg)',
            textTransform: 'uppercase',
            lineHeight: 0.95,
            letterSpacing: '-0.01em',
          }}
        >
          Acampamento
        </div>
        <div
          className="pixel"
          style={{
            fontSize: '0.5625rem',
            color: 'var(--texto-fraco)',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            marginTop: '0.2rem',
          }}
        >
          {subtitulo ?? 'TeensIBP'}
        </div>
      </div>
    </div>
  );
}
